import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Person, PersonRole } from '../domain/Bet.domain'

interface CreatePersonInput {
  name: string
  role: PersonRole
}

export const useCreatePerson = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreatePersonInput) => {
      const response = await api.post<Person>('/persons', data)
      return response.data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Persons] })
    },
  })
}
